import OspInput from './OspInput.vue';

export default OspInput;



// WEBPACK FOOTER //
// ./src/components/OspInput/index.js